import { gql } from "@apollo/client";

export const cameraFragment = gql`
    fragment CameraFragment on Camera {
        id
        activatedAt
        initialActivationAt
        name
        cameraId
        activationPin
        type
        country
        status
        configurationStatus
        lastReceivedImageAt
        basicLicenceInMonths
        premiumLicenceInMonths
        licenceInfo {
            basicEndDate
            premiumEndDate
        }
        user {
            id
            firstname
            lastname
            email
        }
        hardwareInfo {
            imei
            sn
            msisdn
            firmware
        }
    }
`;
